import { initDependencies, setupDependencies } from './app';
import { initFirstCriticalResource } from './firstCriticalResource';

function init() {
  let fullBundleLoaded = false;

  setupDependencies();

  initDependencies();

  setTimeout(() => {
    if (!fullBundleLoaded) {
      initFirstCriticalResource();
    }
  }, 50);

  const initFullApp = () => {
    import('./full').then(({ init: fullInit }) => {
      fullBundleLoaded = true;
      fullInit();
    });
  };
  initFullApp();
}

window.__countryside_card_frontend_init = init;

if (module.hot) {
  module.hot.accept();
}
